import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import Error from '../../pages/Error'
import { getStudentProgress } from '../../../services/vu'
import { getCourseId } from '../../../helpers/course'
import {
  updateDBStepProgress,
  getCurrentPage,
  setStepProgress
} from '../../../helpers/steps'
import Loading from '../../pages/Loading'

class LoadNav extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false
    }
  }

  componentDidMount() {
    const courseId = getCourseId()

    if (courseId) {
      getStudentProgress(courseId).then(nav => {
        const currentPage = getCurrentPage()

        if (typeof nav !== 'string' && currentPage !== nav.currentPage) {
          setStepProgress(nav.navigationSteps)
          this.setState({
            loaded: false
          })
        }

        this.setState({
          loaded: true
        })
      })
    } else {
      this.setState({
        loaded: true
      })
    }
  }

  render() {
    if (this.state.loaded) {
      return this.props.children
    }

    return <Loading />
  }
}

export default withRouter(LoadNav)
